var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from "react";
import { useStore } from "effector-react";
import { useSnackbar } from "notistack";
import { makeStyles } from "@material-ui/core/styles";
import { $notifications, removeNotification } from "./model";
var displayed = [];
var useStyles = makeStyles(function (theme) { return ({
    glass: {
        color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
        backgroundColor: theme.palette.type === "dark"
            ? "rgba(20, 26, 38, 0.58) !important"
            : "rgba(255, 255, 255, 0.48) !important",
        backdropFilter: "blur(24px) saturate(155%)",
        WebkitBackdropFilter: "blur(24px) saturate(155%)",
        border: "1px solid rgba(255, 255, 255, 0.24)",
        borderRadius: 8,
        boxShadow: theme.palette.type === "dark"
            ? "0 18px 44px rgba(0, 0, 0, 0.32)"
            : "0 18px 44px rgba(0, 0, 0, 0.18)",
        overflow: "hidden",
        "& #notistack-snackbar": {
            fontWeight: 500,
            textShadow: theme.palette.type === "dark"
                ? "0 1px 12px rgba(0, 0, 0, 0.32)"
                : "0 1px 12px rgba(255, 255, 255, 0.35)",
        },
        "& svg": {
            color: "inherit",
        },
    },
    success: {
        borderLeft: "4px solid rgba(76, 175, 80, 0.9)",
    },
    error: {
        borderLeft: "4px solid rgba(218, 32, 50, 0.95)",
    },
    warning: {
        borderLeft: "4px solid rgba(255, 171, 64, 0.95)",
    },
    info: {
        borderLeft: "4px solid rgba(91, 151, 255, 0.95)",
    },
}); });
export var Notifier = function () {
    var classes = useStyles();
    var notifications = useStore($notifications);
    var _a = useSnackbar(), enqueueSnackbar = _a.enqueueSnackbar, closeSnackbar = _a.closeSnackbar;
    var storeDisplayed = function (id) {
        displayed = __spreadArray(__spreadArray([], displayed), [id]);
    };
    var removeDisplayed = function (id) {
        displayed = __spreadArray([], displayed.filter(function (key) { return id !== key; }));
    };
    React.useEffect(function () {
        notifications.forEach(function (_a) {
            var key = _a.id, message = _a.message, _b = _a.options, options = _b === void 0 ? {} : _b;
            if (displayed.includes(key))
                return;
            var variantClass = typeof options.variant === "string" && options.variant in classes
                ? classes[options.variant]
                : "";
            enqueueSnackbar(message, __assign(__assign({ key: key }, options), { className: [classes.glass, variantClass, options.className]
                    .filter(Boolean)
                    .join(" "), onClose: function (event, reason, myKey) {
                    if (options.onClose) {
                        options.onClose(event, reason, myKey);
                    }
                }, onExited: function (event, myKey) {
                    removeNotification(myKey);
                    removeDisplayed(myKey);
                } }));
            storeDisplayed(key);
        });
    }, [notifications, closeSnackbar, enqueueSnackbar, classes]);
    return null;
};
